import {useEffect, useLayoutEffect, useRef, useState} from "react";

import {RequestState} from "@pg-mono/request-state";

import {scrollToElementById} from "../../../utils/scroll_to_element_by_id";
import {PropertyListTabTypes} from "../actions/fetch_offer_detail_properties";

const OFFER_PROPERTIES_SECTION_ID = "nieruchomosci";
const PROMOTION_ANCHOR_HASH = "#promocje";
const PROMOTION_ANCHOR_SCROLL_OFFSET = 150;
const PROMOTION_ANCHOR_SCROLL_RETRY_DELAYS_MS = [100, 300, 700, 1200];
const PROMOTION_ANCHOR_SCROLL_SETTLE_MS = 1400;

interface IUsePromotionAnchorPropertyListScrollParams {
    activeTab: PropertyListTabTypes;
    promotionRequestState: RequestState;
    propertyListCurrentTab: PropertyListTabTypes;
    setActivePropertyTab: (tab: PropertyListTabTypes) => void;
    showPromotionTab: boolean;
}

export const usePromotionAnchorPropertyListScroll = (params: IUsePromotionAnchorPropertyListScrollParams) => {
    const {activeTab, promotionRequestState, propertyListCurrentTab, setActivePropertyTab, showPromotionTab} = params;

    const promotionAnchorHandledRef = useRef(false);
    const promotionAnchorPendingRef = useRef(typeof window !== "undefined" && window.location.hash === PROMOTION_ANCHOR_HASH);
    const [shouldScrollToPromotionProperties, setShouldScrollToPromotionProperties] = useState(false);

    useLayoutEffect(() => {
        if (!promotionAnchorPendingRef.current || !showPromotionTab || typeof window === "undefined" || window.location.hash !== PROMOTION_ANCHOR_HASH) {
            return;
        }

        window.history.replaceState(window.history.state, document.title, `${window.location.pathname}${window.location.search}`);
    }, [showPromotionTab]);

    useEffect(() => {
        if (promotionAnchorHandledRef.current || !promotionAnchorPendingRef.current || !showPromotionTab) {
            return;
        }

        promotionAnchorHandledRef.current = true;
        promotionAnchorPendingRef.current = false;
        setActivePropertyTab(PropertyListTabTypes.PROMOTION);
        setShouldScrollToPromotionProperties(true);
    }, [setActivePropertyTab, showPromotionTab]);

    useEffect(() => {
        if (
            !shouldScrollToPromotionProperties ||
            activeTab !== PropertyListTabTypes.PROMOTION ||
            propertyListCurrentTab !== PropertyListTabTypes.PROMOTION ||
            promotionRequestState === RequestState.Waiting ||
            typeof window === "undefined"
        ) {
            return;
        }

        let frameId: number | null = null;

        const scrollToPromotionProperties = () => {
            scrollToElementById(document.documentElement, OFFER_PROPERTIES_SECTION_ID, PROMOTION_ANCHOR_SCROLL_OFFSET, "auto");
        };

        const scheduleScrollToPromotionProperties = () => {
            if (frameId !== null) {
                window.cancelAnimationFrame(frameId);
            }

            frameId = window.requestAnimationFrame(() => {
                frameId = null;
                scrollToPromotionProperties();
            });
        };

        scheduleScrollToPromotionProperties();

        const timeoutIds = PROMOTION_ANCHOR_SCROLL_RETRY_DELAYS_MS.map((delay) => window.setTimeout(scheduleScrollToPromotionProperties, delay));
        const settleTimeoutId = window.setTimeout(() => setShouldScrollToPromotionProperties(false), PROMOTION_ANCHOR_SCROLL_SETTLE_MS);

        const resizeObserver =
            "ResizeObserver" in window
                ? new window.ResizeObserver(() => {
                      scheduleScrollToPromotionProperties();
                  })
                : null;

        resizeObserver?.observe(document.body);

        const target = window.document.getElementById(OFFER_PROPERTIES_SECTION_ID);
        if (target) {
            resizeObserver?.observe(target);
        }

        return () => {
            if (frameId !== null) {
                window.cancelAnimationFrame(frameId);
            }

            timeoutIds.forEach((timeoutId) => window.clearTimeout(timeoutId));
            window.clearTimeout(settleTimeoutId);
            resizeObserver?.disconnect();
        };
    }, [activeTab, promotionRequestState, propertyListCurrentTab, shouldScrollToPromotionProperties]);
};
import {useEffect, useLayoutEffect, useRef, useState} from "react";

import {RequestState} from "@pg-mono/request-state";

import {scrollToElementById} from "../../../utils/scroll_to_element_by_id";
import {PropertyListTabTypes} from "../actions/fetch_offer_detail_properties";

const OFFER_PROPERTIES_SECTION_ID = "nieruchomosci";
const PROMOTION_ANCHOR_HASH = "#promocje";
const PROMOTION_ANCHOR_SCROLL_OFFSET = 150;
const PROMOTION_ANCHOR_SCROLL_RETRY_DELAYS_MS = [100, 300, 700, 1200];
const PROMOTION_ANCHOR_SCROLL_SETTLE_MS = 1400;

interface IUsePromotionAnchorPropertyListScrollParams {
    activeTab: PropertyListTabTypes;
    promotionRequestState: RequestState;
    propertyListCurrentTab: PropertyListTabTypes;
    setActivePropertyTab: (tab: PropertyListTabTypes) => void;
    showPromotionTab: boolean;
}

export const usePromotionAnchorPropertyListScroll = (params: IUsePromotionAnchorPropertyListScrollParams) => {
    const {activeTab, promotionRequestState, propertyListCurrentTab, setActivePropertyTab, showPromotionTab} = params;

    const promotionAnchorHandledRef = useRef(false);
    const promotionAnchorPendingRef = useRef(typeof window !== "undefined" && window.location.hash === PROMOTION_ANCHOR_HASH);
    const [shouldScrollToPromotionProperties, setShouldScrollToPromotionProperties] = useState(false);

    useLayoutEffect(() => {
        if (!promotionAnchorPendingRef.current || !showPromotionTab || typeof window === "undefined" || window.location.hash !== PROMOTION_ANCHOR_HASH) {
            return;
        }

        window.history.replaceState(window.history.state, document.title, `${window.location.pathname}${window.location.search}`);
    }, [showPromotionTab]);

    useEffect(() => {
        if (promotionAnchorHandledRef.current || !promotionAnchorPendingRef.current || !showPromotionTab) {
            return;
        }

        promotionAnchorHandledRef.current = true;
        promotionAnchorPendingRef.current = false;
        setActivePropertyTab(PropertyListTabTypes.PROMOTION);
        setShouldScrollToPromotionProperties(true);
    }, [setActivePropertyTab, showPromotionTab]);

    useEffect(() => {
        if (
            !shouldScrollToPromotionProperties ||
            activeTab !== PropertyListTabTypes.PROMOTION ||
            propertyListCurrentTab !== PropertyListTabTypes.PROMOTION ||
            promotionRequestState === RequestState.Waiting ||
            typeof window === "undefined"
        ) {
            return;
        }

        let frameId: number | null = null;

        const scrollToPromotionProperties = () => {
            scrollToElementById(document.documentElement, OFFER_PROPERTIES_SECTION_ID, PROMOTION_ANCHOR_SCROLL_OFFSET, "auto");
        };

        const scheduleScrollToPromotionProperties = () => {
            if (frameId !== null) {
                window.cancelAnimationFrame(frameId);
            }

            frameId = window.requestAnimationFrame(() => {
                frameId = null;
                scrollToPromotionProperties();
            });
        };

        scheduleScrollToPromotionProperties();

        const timeoutIds = PROMOTION_ANCHOR_SCROLL_RETRY_DELAYS_MS.map((delay) => window.setTimeout(scheduleScrollToPromotionProperties, delay));
        const settleTimeoutId = window.setTimeout(() => setShouldScrollToPromotionProperties(false), PROMOTION_ANCHOR_SCROLL_SETTLE_MS);

        const resizeObserver =
            "ResizeObserver" in window
                ? new window.ResizeObserver(() => {
                      scheduleScrollToPromotionProperties();
                  })
                : null;

        resizeObserver?.observe(document.body);

        const target = window.document.getElementById(OFFER_PROPERTIES_SECTION_ID);
        if (target) {
            resizeObserver?.observe(target);
        }

        return () => {
            if (frameId !== null) {
                window.cancelAnimationFrame(frameId);
            }

            timeoutIds.forEach((timeoutId) => window.clearTimeout(timeoutId));
            window.clearTimeout(settleTimeoutId);
            resizeObserver?.disconnect();
        };
    }, [activeTab, promotionRequestState, propertyListCurrentTab, shouldScrollToPromotionProperties]);
};
